module.exports = __webpack_public_path__ + "img/report.d746dd08.svg";